export const animateValue = (elm, end, duration = 5000, start = 0) => {
    if (typeof end === "string") {
        end = parseInt(end.replace(/\,/g, ""));
    }

    if (typeof duration === "string") {
        duration = parseInt(duration);
    }
    // assumes integer values for start and end
    var range = end - start;
    // no timer shorter than 50ms (not really visible any way)
    var minTimer = 50;
    // calc step time to show all interediate values
    var stepTime = Math.abs(Math.floor(duration / range));
    
    // never go below minTimer
    stepTime = Math.max(stepTime, minTimer);
    
    // get current time and calculate desired end time
    var startTime = new Date().getTime();
    var endTime = startTime + duration;
    var timer;
  
    function run() {
        var now = new Date().getTime();
        var remaining = Math.max((endTime - now) / duration, 0);
        var value = Math.round(end - (remaining * range));
        elm.innerHTML = value.toLocaleString();
        if (value == end) {
            clearInterval(timer);
        }
    }
    
    timer = setInterval(run, stepTime);
    run();
}